import { buildApiUrl } from './api';

export type Connection = {
    appId: string;
    createdAt: string;
};

type ErrorResponse = {
    code: string;
};

type FaultResponse = {
    message: string;
    errors: ErrorResponse[];
};

type SuccessfulGetBody = {
    connections: any; // TODO описать
};

type SuccessfulOauthUnConnectBody = {
    status: boolean;
};

type BadRequestBody = FaultResponse;

type ConnectionServiceGetResponse = Omit<Response, 'json'> & {
    status: 200;
    json: () => SuccessfulGetBody | PromiseLike<SuccessfulGetBody>;
};

type ConnectionServiceUnConnectResponse =
    | (Omit<Response, 'json'> & {
          status: 200;
          json: () => SuccessfulOauthUnConnectBody | PromiseLike<SuccessfulOauthUnConnectBody>;
      })
    | (Omit<Response, 'json'> & {
          status: 400;
          json: () => BadRequestBody | PromiseLike<BadRequestBody>;
      });

type ConnectionServiceUnConnectRequest = {
    appId: string;
};

class ConnectionService {
    static async get() {
        const response = (await fetch(buildApiUrl('/connections'), {
            method: 'GET'
        })) as ConnectionServiceGetResponse;

        if (response.status === 200) {
            return response.json();
        }

        throw Error('Unhandled response code');
    }

    static async unConnect(data: ConnectionServiceUnConnectRequest) {
        const response = (await fetch(buildApiUrl('/connection/unconnect'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })) as ConnectionServiceUnConnectResponse;

        if (response.status === 200) {
            return response.json();
        }

        throw Error('Unhandled response code');
    }
}

export default ConnectionService;
